import { passPhTracker } from '@/integrations/trackingScripts/utils';

type BentoCtaLinkProps =
  | ({
      as: 'a';
      href: string;
      target?: '_blank';
    } & ReturnType<typeof passPhTracker>)
  | Record<string, never>;

/** Link props for Decoro `Button` when a bento CTA has an href. */
export function getBentoCtaLinkProps(
  ctaHref?: string,
  ctaTarget?: '_blank',
  phTracker?: string
): BentoCtaLinkProps {
  if (!ctaHref) {
    return {};
  }

  return {
    as: 'a',
    href: ctaHref,
    target: ctaTarget,
    ...passPhTracker(phTracker),
  };
}
